import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { IMfaKeyProps } from './IMfaKeyProps';
import { secretGroups } from './mfaCode';

/**
 * Ключ для ручного введення (коли QR не сканується): «Не вдається відсканувати? Введіть ключ вручну:» і праворуч «Копіювати» (у буфер
 * обміну без пробілів; без доступу до буфера ключ просто виділяється), під ними — ключ моноширинним групами по 4 (виділяється цілим).
 */
export function MfaKey({ secret }: IMfaKeyProps) {
  const { t } = useTranslation();
  const valueRef = useRef<HTMLSpanElement>(null);
  const [copied, setCopied] = useState(false);
  const select = () => { if (valueRef.current) window.getSelection()?.selectAllChildren(valueRef.current); };
  const copy = () => {
    const done = () => { setCopied(true); window.setTimeout(() => setCopied(false), 2000); };
    if (navigator.clipboard) navigator.clipboard.writeText(secret).then(done, select);
    else select();
  };
  return (
    <div className="au-key">
      <div className="au-key__head">
        <span className="au__label">{t('auth.mfa.manual')}</span>
        <button type="button" className="au__linkbtn au-key__copy" onClick={copy}>{t(copied ? 'auth.mfa.copied' : 'auth.mfa.copy')}</button>
      </div>
      <span ref={valueRef} className="au-key__value" aria-label={t('auth.mfa.key')}>{secretGroups(secret)}</span>
    </div>
  );
}
